import React from 'react';

import { currencyTypes } from './actions'

import {formatMoney} from '../../utils'


const initialState = {
    isFetching: false,
}


export function currency(state = initialState, action) {
    let existing = null


    switch(action.type) {

        case currencyTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case currencyTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.short_code = action.data.short_code
            state.value = formatMoney(action.data.values[0].value, 0)


            return state


        default:
            return state
    }
}